export const BOOKING_LINK_HEADER = "X-Meeting-Booking-Link"

export const BOOKING_API = {
  info: "/crm/api/public/meeting-booking/",
  availability: "/crm/api/public/meeting-booking/availability/",
  create: "/crm/api/public/meeting-booking/meetings/",
}

const LINK_PROBLEM_CODES = ["invalid", "expired", "revoked"]

// A link the server refused (unknown, expired or turned off): the page cannot
// be used at all, as opposed to a problem with one booking attempt.
export function isLinkProblem(error) {
  return (
    error?.response?.status === 401 &&
    LINK_PROBLEM_CODES.includes(error.response.data?.code)
  )
}
